module.exports = __webpack_public_path__ + "img/catagory5.cb914423.png";